export default __webpack_public_path__ + "static/snbz-web-db5a42436821045e7a216b409118f223.jpg";